import { isValid } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import moment from "moment";
import Bugsnag from "@bugsnag/js";
import { safeParseDateString } from "utils/date-helpers";

export function getScheduleDisplay(
  scheduledFor: moment.MomentInput,
  timePreference: string | undefined,
  timezone?: string
): string {
  const displayDateFormat =
    timePreference === "12h" ? "EEE d MMM h:mma" : "EEE d MMM HH:mm";

  let date: Date;
  if (moment.isMoment(scheduledFor)) {
    date = scheduledFor.toDate();
  } else if (scheduledFor instanceof Date) {
    date = scheduledFor;
  } else if (typeof scheduledFor === "number") {
    date = new Date(scheduledFor);
  } else if (typeof scheduledFor === "string") {
    // Use safeParseDateString to handle various formats including Safari-incompatible ones
    // Pass timezone to correctly interpret space-separated datetime strings
    date = safeParseDateString(scheduledFor, timezone);
  } else {
    // MomentInputObject or array - let moment parse it then convert to Date
    date = moment(scheduledFor).toDate();
  }

  // Validate before formatting to prevent RangeError: Invalid time value
  if (!isValid(date)) {
    console.error(`[getScheduleDisplay] Invalid date: "${scheduledFor}"`);
    Bugsnag.notify(
      new Error(`Invalid schedule date: ${scheduledFor}`),
      (event) => {
        event.addMetadata("scheduleDisplay", {
          inputValue: String(scheduledFor),
          inputType: typeof scheduledFor,
          timezone: timezone,
          timezoneType: typeof timezone,
        });
      }
    );
    return "Schedule unavailable";
  }

  // Format in user's profile timezone, not browser local timezone (SKE-2716)
  // Use UTC as fallback if timezone not provided
  return formatInTimeZone(date, timezone || "UTC", displayDateFormat);
}
